import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

// Note: WebSocket error filtering is done in public/index.html
// This ensures filtering happens before bundle.js loads

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);



